'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { useAlertBoxContext } from './alert-box.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const AlertBoxDismissButton = renderWithRef('AlertBoxDismissButton', null, (o, u)=>{
    let { onRequestDismiss: a } = useAlertBoxContext(), b = useInternalOptionalSwanI18nContext();
    useDeprecatedProps('AlertBoxDismissButton', o, [
        {
            propName: 'visuallyHiddenLabel',
            instructions: getDeprecatedI18nPropMessage(b)
        },
        {
            propName: 'accessibleText',
            instructions: getDeprecatedI18nPropMessage(b)
        }
    ]);
    let f = new Set([
        'swan-alert-box-close-button'
    ]), { visuallyHiddenLabel: m, accessibleText: d, children: _, onClick: y } = o, j = _object_without_properties(o, [
        "visuallyHiddenLabel",
        "accessibleText",
        "children",
        "onClick"
    ]), x = null != d ? d : m;
    return b && !x && (x = b.t('alert-box-dismiss-button.accessible-text-for-icon')), jsxs(RenderComp, {
        root: "button",
        forwardedRef: u,
        classNames: f,
        props: _object_spread({}, j, {
            onClick: composeEventHandlersUtil(y, ()=>'function' == typeof a && a())
        }),
        children: [
            null != x && jsx(VisuallyHidden, {
                children: x
            }),
            _
        ]
    });
});

export { AlertBoxDismissButton };
